<template>
  <div class="statistics">

    <div class="row">
      <div class="key">合计重量：</div>
      <div class="val">{{ statistics.weight.toFixed(2) }}</div>
    </div>


  </div>
</template>
<script>
export default {
  props: {
    checkedList: { type: Array },

  },
  computed: {
    statistics() {
      // console.log(this.checkedList);
      let total = {
        weight: 0,

      }
      this.checkedList.forEach(item => {
        total.weight += item.weight - 0

      })

      return total
    }
  },
  data() {
    return {

    };
  },
  methods: {

  }
}
</script>
<style lang='scss' scoped>
.row {
  display: flex;
  margin-bottom: 5px;
  color: #000;

  .key {
    width: 80px;
    margin-right: 10px
  }

  .val {
    color: #B4272D;
  }
}
</style>